import * as RadixTooltip from '@radix-ui/react-tooltip'

/** Wrap the app once. Nothing below this needs to know it is here. */
export function TooltipProvider({ children }: { children: React.ReactNode }) {
  return (
    <RadixTooltip.Provider delayDuration={300} skipDelayDuration={100}>
      {children}
    </RadixTooltip.Provider>
  )
}

/**
 * A word for something drawn without one — an icon-only button, a truncated cell.
 *
 * **Never the only place something is said.** A tooltip is invisible to a touch
 * screen and to somebody reading the page rather than pointing at it, so anything
 * that matters is also in the label.
 */
export function Tooltip({
  label,
  children,
}: {
  label: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          sideOffset={6}
          className="z-50 rounded-sm bg-navy px-2 py-1 text-caption text-on-navy shadow-md"
        >
          {label}
          <RadixTooltip.Arrow className="fill-navy" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  )
}
